import { render, staticRenderFns } from "./StorageCN_detail.vue?vue&type=template&id=0e35a943&scoped=true&"
import script from "./StorageCN_detail.vue?vue&type=script&lang=js&"
export * from "./StorageCN_detail.vue?vue&type=script&lang=js&"
import style0 from "./StorageCN_detail.vue?vue&type=style&index=0&id=0e35a943&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e35a943",
  null
  
)

export default component.exports